import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { ActivityModalComponent } from 'src/app/components/discount/activity-modal/activity-modal.component';
import { DiscountModalComponent } from 'src/app/components/discount/discount-modal/discount-modal.component';
import { HolidayNoticeModalComponent } from 'src/app/components/holiday-notice-modal/holiday-notice-modal.component';
import { TipModalComponent } from 'src/app/components/tip-modal/tip-modal.component';
import { YoutubeRechargeTipModalComponent } from 'src/app/components/youtube-recharge-tip-modal/youtube-recharge-tip-modal.component';
import { YoutubeTipModalComponent } from 'src/app/components/youtube-tip-modal/youtube-tip-modal.component';
import { BusApiService } from 'src/app/services/api/bus-api.service';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit {
  constructor(
    private dialog: MatDialog,
    private api: UserApiService,
    private user: UserService,
    private apiBus: BusApiService
  ) {}

  ngOnInit(): void {
    this.getSelf();

    // this.dialog.open(DiscountModalComponent, {
    //   panelClass: 'discount-dialog',
    //   width: '471px',
    // });

    const endTime = new Date('2026-01-07T23:59:59');
    if (Date.now() < endTime.getTime()) {
      this.dialog.open(ActivityModalComponent, {
        panelClass: 'discount-dialog',
        width: '450px',
      });
    }

    // 2026/02/14-2026/02/25 弹窗显示
    const now = new Date();
    const startDate = new Date(2026, 1, 14, 0, 0, 0);
    const stopDate = new Date(2026, 1, 24, 0, 0, 0);
    if (now < stopDate && now >= startDate) {
      this.dialog.open(HolidayNoticeModalComponent, {
        panelClass: 'holiday-modal',
      });
    }
  }

  async getSelf() {
    try {
      const r = await this.user.getSelf();
      if (r) {
        // this.checkYoutubeRecharge();
      }
      if (!r.wechat_notice) {
        this.dialog
          .open(TipModalComponent, {
            panelClass: 'tip-dialog',
          })
          .afterClosed()
          .subscribe((r) => {
            this.wechatNotice();
          });
      }
      // if (!r?.is_tester && r?.youtube) {
      //   this.dialog
      //     .open(YoutubeTipModalComponent, {
      //       panelClass: 'tip-dialog',
      //     })
      //     .afterClosed()
      //     .subscribe((r) => {
      //       this.isTester();
      //     });
      // }
    } catch (error) {}
  }

  async wechatNotice() {
    try {
      await this.api.wechatNoticeModalClose(true);
    } catch (error) {
    } finally {
      this.changeSelf();
    }
  }

  async changeSelf() {
    try {
      const r = await this.api.getSelf();
      this.user.setSelf(r.data);
    } catch (error) {}
  }

  async isTester() {
    try {
      const r = await this.api.isTester(true);
    } catch (error) {
    } finally {
      this.changeSelf();
    }
  }

  async checkYoutubeRecharge() {
    try {
      const r = await this.apiBus.checkYoutubeRecharge();
      if (r.data) {
        this.dialog.open(YoutubeRechargeTipModalComponent, {
          width: '582px',
        });
      }
    } catch (error) {}
  }
}
